import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var TagStyle = function TagStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary1 = _getThemeData.primary1,
    primary6 = _getThemeData.primary6;
  var _getThemeData2 = getThemeData(props, 'tag'),
    padding = _getThemeData2.padding;
  return css([".ant-tag.ant-tag{border:transparent;padding:", ";}.ant-tag.ant-tag:not([class*='ant-tag-']){color:", ";border:transparent;background:", ";.anticon-cross{color:", ";}}.ant-tag.ant-tag-checkable:hover,.ant-tag.ant-tag-checkable{background-color:", ";color:", ";}.ant-tag-checkable-checked.ant-tag-checkable-checked:hover,.ant-tag-checkable-checked.ant-tag-checkable-checked{background-color:", ";color:#fff;}"], padding, primary6, primary1, primary6, primary1, primary6, primary6);
};
export default TagStyle;